import React, { Component, Fragment } from 'react';
import ScrollToTopOnMount from './ScrollToTopOnMount'
import PropTypes from 'prop-types';
import {taxRateBefore20191001, taxRateAfter20191001, taxChangeBorder, bedPrice, mealPrice, roomPlans, roomNames} from './Settings';
import { API } from 'aws-amplify';
import { withRouter } from 'react-router';
import AuthService from './services/AuthService'
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Chip from '@material-ui/core/Chip';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import ErrorIcon from '@material-ui/icons/Error';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import CircularProgress from '@material-ui/core/CircularProgress';
import moment from 'moment';
import axios from 'axios';
import cheerio from 'cheerio'
import { withSnackbar } from 'notistack';

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 300,
  },
  formControl: {
    margin: theme.spacing.unit
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
  button: {
    margin: theme.spacing.unit,
  },
  PlasticBagCheckboxFormControl: {
    marginLeft: 30,
  },
});

let id = 0;
const createPlan = (basePlan, bedPlan, mealPlan, unitPrice, amount) => {
  id += 1;
  return { id, basePlan, bedPlan, mealPlan, unitPrice, amount };
}


const initialState = {
  date: "",
  dateNum: "1",
  inputRooms: [],
  rooms:[],
  roomError: false,
  inputBasePlan:"",
  inputBedPlan: "",
  inputMealPlan:"",
  inputUnitPrice: "",
  inputAmount: "",
  plans:[],
  planError: "none",
  isJalan: "no",
  isActiveJalanSiteController: "no",
  isWaitingSiteController: false,
  jalanPaid: "no",
  extraCharge:"",
  discount:"",
  gotoDiscount:"no",
  jalanNumber:"",
  jalanPoint:"",
  jalanCoupon:"",
  jalanSubsidy:"",
  taxRate: "",
  planShortageError:"none",
  planNegativeError:"none",
  babyChairs: "0",
  joinBed: "0",
  plasticBag: "no",
  familyMemberOpen: false,
  scroll: "paper",
  babyM: "",
  babyW: "",
  kindergartenM: "",
  kindergartenW: "",
  elementarySchoolLowM: "",
  elementarySchoolLowW: "",
  elementarySchoolMiddleM: "",
  elementarySchoolMiddleW: "",
  elementarySchoolHighM: "",
  elementarySchoolHighW: "",
  juniorHighSchoolM: "",
  juniorHighSchoolW: "",
  highSchoolM: "",
  highSchoolW: "",
  universityM: "",
  universityW: "",
  twentiesM: "",
  twentiesW: "",
  thirtiesM: "",
  thirtiesW: "",
  fortiesM: "",
  fortiesW: "",
  fiftiesM: "",
  fiftiesW: "",
  sixtiesM: "",
  sixtiesW: "",
  overSeventiesM: "",
  overSeventiesW: "",
  transportation: "",
  planNote: "",
  isRepeatCustomer: "no",
  repeatCustomerId: "",
  searchCustomersResult: [],
  repeatCustomerOpen: false,
  lastNameKanaSC: "",
  firstNameKanaSC: "",
  telSC: "",
  emailSC: "",
  lastName: "",
  lastNameOnFocus: "no",
  firstName: "",
  lastNameKana: "",
  lastNameKanaOnFocus : "no",
  lastNameList: [],
  firstNameKana: "",
  tel: "",
  tel2: "",
  email: "",
  postNum:"",
  addressPrefectures:"",
  addressCity:"",
  addressOther:"",
  addressBuilding:"",
  customerNote:"",
};



class Reservation extends Component {

  constructor(props) {
    super(props);
    this.state = initialState;
    this.authApi = new AuthService();
  }

  reset(){
    this.setState(initialState);
    //ページ遷移して戻ってくると、stateのplansだけ消えない問題の対策
    this.setState({
      plans:[]
    });
  }

  componentWillMount(){
    //ページ遷移して戻ってくると、stateのplansだけ消えない問題の対策
    this.reset();

    if (process.env.NODE_ENV === 'development') {
      // テスト用
      this.setState({
        // date: "2021-03-15",
        // dateNum: "2",
        // inputRooms: ["A", "F", "I"],
        // plans:[{
        //   amount: 2,
        //   basePlan: "大人",
        //   bedPlan: "有",
        //   id: 1,
        //   mealPlan: "2食付",
        //   unitPrice: "10000"
        // }],

        lastName: "時田",
        firstName: "明典",
        lastNameKana: "トキタ",
        firstNameKana: "アキノリ",
        tel: "09035782830",
        tel2: "0559981433",
        email: "akinori.tokita@gmail.com",
        postNum:"1730032",
        addressPrefectures:"東京都",
        addressCity:"板橋区",
        addressOther:"大谷口上町85-1",
        addressBuilding:"OKコートKOTAKE 104",
        customerNote: "備考1行目\n備考2行目",
        // isJalan: "no",
        // jalanNumber: "123456",
        // jalanPoint: "500",
        // jalanCoupon: "400",
        // jalanSubsidy: "300",
      })
    }

    this.authApi.isLogin()
    .then(
      (login) => {
        if(!login){
          this.props.history.push('/login');
        }
      }
    );

    //デフォルトの日付入力
    this.handleChange({target: {value: moment().format("YYYY-MM-DD")}}, "date")

    //空室表から飛んできたときの部屋と日付の入力
    const { location } = this.props

    if(location.search !== ""){
      let queryArg = {};
      let pair=location.search.substring(1).split('&');
      for(var i=0;pair[i];i++) {
          var kv = pair[i].split('=');
          queryArg[kv[0]]=kv[1];
      }

      this.handleChange({target: {value: moment(queryArg.date).format("YYYY-MM-DD")}}, "date")

      let event = {target: {value: [queryArg.room]}}
      this.handleChange(event, "inputRooms")
    }

    //カレンダーから飛んできた時に、メニューのハイライトを反映するためにパスをセット
    this.props.setPath();
  }

  handleChange = (event, key) => {

    this.setState({
      [key] : event.target.value
    }, () => {
      console.log(this.state)
      if(key === "inputBasePlan" && this.state.inputBasePlan === "素泊り"){
        this.setState({
          inputMealPlan: "無"
        })
      }

      if(key === "date"){

        let taxChangeDate = moment(taxChangeBorder)
        let date = moment (this.state.date)
        let taxRate = taxRateBefore20191001;

        if(date.isAfter(taxChangeDate)){
          taxRate = taxRateAfter20191001
        }

        this.setState({
          taxRate: taxRate
        })
      }

      if(key === "inputBasePlan" && this.state.inputBasePlan !== "" && this.state.inputBasePlan !== "素泊り"){

        let inputBedPlan
        let inputMealPlan
        let inputAmount

        if(this.state.inputBasePlan === "大人"){
          inputBedPlan = "有"
          inputMealPlan ="2食付"
          inputAmount = 2
        }
        if(this.state.inputBasePlan === "ジュニア"){
          inputBedPlan = "有"
          inputMealPlan = "2食付"
          inputAmount = 1
        }
        if(this.state.inputBasePlan === "キッズ"){
          inputBedPlan = "無"
          inputMealPlan = "2食付"
          inputAmount = 1
        }
        this.setState({
          inputBedPlan: inputBedPlan,
          inputMealPlan: inputMealPlan,
          inputAmount: inputAmount
        },() => {
          if(this.state.rooms.length !== 0){
            this.setState({
              inputUnitPrice: this.calculatePrice()
            })
          }
        })
      }

      if(key === "inputRooms"){
        let roomLength = this.state.inputRooms.length;
        if(roomLength === 0){
          this.setState({
            rooms:[],
            roomError: true
          })
        }else{
          let rooms = []
          this.state.inputRooms.forEach(value =>{
            let room = roomPlans.filter((item) => {
              return item.name === value;
            });
            rooms.push(room[0])
          })
          this.setState({
            rooms:rooms,
            roomError: false
          },() => {
            if(
                this.state.inputBasePlan !== "" &&
                this.state.inputBedPlan !== ""
            ){
              this.setState({
                inputUnitPrice: this.calculatePrice()
              })
            }
          })
        }
      }

      if(
          (
            key === "inputBedPlan" ||
            key === "inputMealPlan"
          )
          &&
          (
            this.state.rooms.length !== 0 &&
            this.state.inputBasePlan !== "" &&
            this.state.inputBedPlan !== ""
          )
      ){
        this.setState({
          inputUnitPrice: this.calculatePrice()
        })

        if(this.state.inputBasePlan === "素泊り"){
          this.setState({
            inputUnitPrice: this.calculatePrice(),
            inputAmount: "1"
          })
        }
      }

    });
  }

  handleChangeCheck = (event, key) => {
    if(event.target.checked){
      this.setState({ [key] : "yes" });
    }else{
      this.setState({ [key] : "no" });
    }

    if(key === "isJalan"){
      if(event.target.checked){
        this.setState({
           extraCharge : "",
           discount : "",
           gotoDiscount: "no"
        });
      }else{
        this.setState({
          jalanPaid: "no",
          jalanNumber:"",
          jalanPoint: "",
          jalanCoupon: "",
          jalanSubsidy: ""
        });
      }
    }

    if(key === "isRepeatCustomer"){
      if(!event.target.checked){
        this.setState({
          repeatCustomerId : ""
        });
      }
    }

  }

  doSearch = (event, key) => {
    let value = event.target.value; // this is the search text

    this.setState({
      [key]: value
    })

    if(this.timeout) clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      if(key === "lastNameKana"){
        this.getLastName(value)
        this.handleSearchCustomers()
      }

      if(key === "postNum"){
        value = value.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => {
          return String.fromCharCode(s.charCodeAt(0) - 65248);
        });
        this.getAddress(value)
      }
    }, 1000);
  }

  changeChar = (event, key) => {
    let value = event.target.value; // this is the search text

    value = value.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => {
      return String.fromCharCode(s.charCodeAt(0) - 65248);
    });

    this.setState({
      [key]: value
    })
  }

  handleSubmit = (event) => {
    event.preventDefault();

    if(this.state.inputRooms.length === 0){
      this.setState({
        roomError: true
      })
      const { enqueueSnackbar } = this.props;
      enqueueSnackbar("お部屋を指定してください。",{variant : 'warning'});
    }else{
      this.setState({
        roomError: false
      })
    }

    if(this.state.plans.length === 0){
      this.setState({
        planError: ""
      })
      const { enqueueSnackbar } = this.props;
      enqueueSnackbar("プランを入力してください。",{variant : 'warning'})
    }else{
      this.setState({
        planError: "none"
      })
    }

    if(this.state.isRepeatCustomer === "yes" && this.state.repeatCustomerId === ""){
      const { enqueueSnackbar } = this.props;
      enqueueSnackbar("リピーター情報を設定してください",{variant : 'warning'})
    }

    // TODO 合計金額がマイナスでないかチェック

    if(
      this.state.inputRooms.length !== 0 &&
      this.state.plans.length !== 0 &&
      ((this.state.isRepeatCustomer === "yes" && this.state.repeatCustomerId !== "") || (this.state.isRepeatCustomer === "no"))
    ){

      let createReservation = () => {
        this.setState({
          lastNameList: [],
          searchCustomersResult:[]
        },() => {
          let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
          let path = '/reservations'; //replace this with the path you have configured on your API
          let myInit = {
              body: this.state,
          }

          const { enqueueSnackbar } = this.props;

          API.post(apiName, path, myInit).then(response => {
            console.log(response)
            enqueueSnackbar(response.message, {variant : 'success'});
            this.props.history.push('/main/reservation-manage?reservationId=' + response.reservationId);
          }).catch(error => {
            console.log(error)
            if(error.message){
              enqueueSnackbar(error.message, {variant : 'error'})
            }else{
              enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
            }
          });
        })
      }


      //サイトコントローラーの動作有無
      if(this.state.isActiveJalanSiteController === "no" && this.state.isJalan === "no"){
        //サイトコントローラーでじゃらんの在庫を減らす場合

        this.setState({
          isWaitingSiteController: true
        },() => {
          let apiName = 'MyAPIGatewayAPI'
          let path = '/jalan/decrease'

          let body = {
            date: this.state.date,
            dateNum: this.state.dateNum,
            inputRooms : this.state.inputRooms
          }

          let myInit = {
            body: body
          }

          const { enqueueSnackbar } = this.props;
          API.post(apiName, path, myInit).then(async (response) => {

            let executionArn = response.executionArn

            console.log(response)

            let path = '/jalan/decrease/status'

            let body = {
              executionArn : executionArn
            }

            let myInit = {
              body: body
            }

            //結果をポーリング

            function sleep(waitSec) {
              return new Promise(function (resolve) {
                setTimeout(function() { resolve() }, waitSec);
              });
            }

            let res

            let count = 0
            while (count < 40) {

              try{
                res = await API.post(apiName, path, myInit)
                console.log(res)

                if(res.status === "RUNNING"){
                  count++
                  await sleep(3000)
                }else{
                  break
                }

              }catch(error){

                console.log(error)
                if(error.message){
                  enqueueSnackbar(error.message, {variant : 'error'})
                  this.setState({
                    isWaitingSiteController: false
                  })
                }else{
                  enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
                  this.setState({
                    isWaitingSiteController: false
                  })
                }
                break
              }
            }

            if(res.status === "SUCCEEDED"){

              if(res.output.message !== "success"){
                enqueueSnackbar(res.output.message, {variant : 'error', autoHideDuration : 20000})
                this.setState({
                  isWaitingSiteController: false
                })
              }else{
                if(res.output.beforeSale.length > 0){
                  res.output.beforeSale.map(item => {
                    let message = moment(item.date).format('YYYY年M月D日') + ' の ' + item.roomName + ' はじゃらんで販売開始前のため、じゃらんの在庫は変更されませんでした。'
                    enqueueSnackbar(message, {variant : 'warning', autoHideDuration : 20000})
                  })
                }

                if(res.output.stopSale.length > 0){
                  res.output.stopSale.map(item => {
                    let message = moment(item.date).format('YYYY年M月D日') + ' の ' + item.roomName + ' はじゃらんで販売停止中のため、じゃらんの在庫は変更されませんでした。'
                    enqueueSnackbar(message, {variant : 'warning', autoHideDuration : 20000})
                  })

                }

                createReservation()
              }

            }else{
              enqueueSnackbar('処理中にエラーが発生しました。念の為、じゃらんの在庫状況を確認してください。', {variant : 'error'})
              this.setState({
                isWaitingSiteController: false
              })
            }

          }).catch(error => {

            this.setState({
              isWaitingSiteController: false
            })

            console.log(error)
            if(error.message){
              enqueueSnackbar(error.message, {variant : 'error'})
            }else{
              enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
            }

          });
        })

      }else{
        // サイトコントローラーを使わない場合
        // そのままPMS側だけ予約
        createReservation()
      }
    }
  }

  handleAddPlan = () => {
    if(
      !this.state.inputBasePlan  ||
      !this.state.inputBedPlan  ||
      (this.state.inputBasePlan !== "素泊り" && !this.state.inputMealPlan )  ||
      !this.state.inputUnitPrice ||
      !this.state.inputAmount
    ){
      this.setState({
        planShortageError: ""
      })
    }else{
      if(Number(this.state.inputUnitPrice) >= 1 && Number(this.state.inputAmount) >= 1){
        let plans = this.state.plans
        plans.push(createPlan(
          this.state.inputBasePlan,
          this.state.inputBedPlan,
          this.state.inputMealPlan,
          this.state.inputUnitPrice,
          this.state.inputAmount
        ))
        this.setState({
          plans: plans,
          planShortageError:"none",
          planNegativeError:"none",
          planError: "none"
        },() => {
          this.setState({
            inputBasePlan:"",
            inputBedPlan:"",
            inputMealPlan:"",
            inputUnitPrice: "",
            inputAmount: ""
          });
        });

        if(this.state.inputBedPlan === "無"){
          this.setState({
            joinBed : Number(this.state.joinBed) + Number(this.state.inputAmount)
          });
        }

      }else{
        this.setState({
          planNegativeError: ""
        })
      }
    }
  }

  handleDeletePlan = (id) => {
    let plans = this.state.plans

    const newPlans = plans.filter((item) => {
      return item.id !== id;
    });

    let joinBed = 0

    if(newPlans.length !== 0){
      newPlans.forEach((item) => {
        if(item.bedPlan === "無"){
          joinBed += Number(item.amount)
        }
      })
    }
    this.setState({
      plans: newPlans,
      joinBed: joinBed
    })

  }

  getTotalAmount = () => {
    let totalAmount = 0

    this.state.plans.forEach((item) => {
      totalAmount += Number(item.amount)
    })

    return totalAmount

  }

  calculatePrice = () =>{
    let price = 0

    price += Number(this.state.rooms[0].basePrice[this.state.inputBasePlan])
    if(this.state.inputBedPlan === "無"){
      price -= bedPrice
    }

    if(this.state.inputMealPlan === "夕食付"){
      if(this.state.inputBasePlan === "大人"){
        price -= mealPrice.breakfast.adult
      }

      if(this.state.inputBasePlan === "ジュニア"){
        price -= mealPrice.breakfast.junior
      }

      if(this.state.inputBasePlan === "キッズ"){
        price -= mealPrice.breakfast.kids
      }
    }

    if(this.state.inputMealPlan === "朝食付"){
      if(this.state.inputBasePlan === "大人"){
        price -= mealPrice.dinner.adult
      }

      if(this.state.inputBasePlan === "ジュニア"){
        price -= mealPrice.dinner.junior
      }

      if(this.state.inputBasePlan === "キッズ"){
        price -= mealPrice.dinner.kids
      }
    }

    return price
  }

  getTotalPrice = () => {
    let totalPrice = 0

    this.state.plans.forEach((item) => {
      totalPrice += Number(item.unitPrice) * Number(item.amount)
    })

    return totalPrice

  }

  getAddress = (postNum) => {

    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/address'; //replace this with the path you have configured on your API
    const myInit = { // OPTIONAL
      queryStringParameters: {  // OPTIONAL
        zipcode : postNum
      },
    };

    API.get(apiName, path, myInit).then(response => {
      if(response.status === 200){
        console.log(response.results[0]);

        this.setState({
          addressPrefectures: response.results[0].address1,
          addressCity: response.results[0].address2,
          addressOther: response.results[0].address3
        })
      }else{
        console.log(response.message)
      }
    }).catch(error => {
      console.log(error);
    })
  }

  getLastName = (lastNameKana) => {

    const kanaToHira = (str) => {
        return str.replace(/[\u30a1-\u30f6]/g, function(match) {
            var chr = match.charCodeAt(0) - 0x60;
            return String.fromCharCode(chr);
        });
    }

    const isZenKatakana = (str) =>{
      str = (str==null)?"":str;
      if(str.match(/^[ァ-ンヴー　]*$/)){    //"ー"の後ろの文字は全角スペースです。
        return true;
      }else{
        return false;
      }
    }

    let that = this;
    let keyword = lastNameKana
    let lastNameList = []

    if(isZenKatakana(keyword) && keyword && keyword.length > 1){
      console.log('Searching Last Name. Page: 1')
      keyword = kanaToHira(lastNameKana)
      axios.get('https://myoji-yurai.net/resultList.htm', {
        params: {
          kind : "読み方で",
          keyword: keyword,
        }
      })
      .then((response) => {
        try {
          const $ = cheerio.load(response.data)

          $('#content > div > table > tbody tr').each((i,element)=>{
            let lastNameKana =element.children[1].children[1].children[0].data
            let lastName = element.children[1].children[0].children[0].data

            if (
              lastNameKana.indexOf('(' + keyword + ')') !== -1 ||
              lastNameKana.indexOf(',' + keyword + ',') !== -1 ||
              lastNameKana.indexOf('(' + keyword + ',') !== -1 ||
              lastNameKana.indexOf(',' + keyword + ')') !== -1 ||
              lastNameKana.indexOf('…') !== -1
            ){
              lastNameList.push(lastName)
            }
          })
          that.setState({
            lastNameList: lastNameList,
          })

          const getLastNameMore = (page) => {
            page += 1
            console.log('Searching Last Name. Page: ' + page)
            axios.get('https://myoji-yurai.net/resultList.htm', {
              params: {
                kind : "読み方で",
                keyword: keyword,
                page: page
              }
            }).then((response) =>{
              try {
                const $ = cheerio.load(response.data)
                $('#content > div > table > tbody tr').each((i,element)=>{
                  let lastNameKana =element.children[1].children[1].children[0].data
                  let lastName = element.children[1].children[0].children[0].data

                  if (
                    lastNameKana.indexOf('(' + keyword + ')') !== -1 ||
                    lastNameKana.indexOf(',' + keyword + ',') !== -1 ||
                    lastNameKana.indexOf('(' + keyword + ',') !== -1 ||
                    lastNameKana.indexOf(',' + keyword + ')') !== -1 ||
                    lastNameKana.indexOf('…') !== -1
                  ){
                    lastNameList.push(lastName)
                  }
                })
                that.setState({
                  lastNameList: lastNameList,
                })

                length = $("a:contains('次ページ')").length
                if(length !== 0){
                  getLastNameMore(page)
                }else{
                  console.log('Last Name Search done.')
                }

              }catch(e){
                console.error(e)
              }
            })
          }

          let length = $("a:contains('次ページ')").length
          let page = 1

          if(length > 0){
            getLastNameMore(page)
          }else{
            console.log('Last Name Search done.')
          }

        }catch(e){
          console.error(e)
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    }else{
      console.log("not Zenkakukatakana")
    }
  }

  handleClickOpenDialog = (scroll,name) =>{
    this.setState({ [name]: true, scroll });

    if(name === "repeatCustomerOpen"){
      this.setState({ searchCustomersResult: [] });
    }
  }

  handleCloseDialog = name => {
    this.setState({ [name]: false });
  }

  handleSearchCustomers = () => {
    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/search-customers'; //replace this with the path you have configured on your API
    let myInit = {
        body: {
          lastNameKanaSC: this.state.lastNameKanaSC ? this.state.lastNameKanaSC : this.state.lastNameKana,
          firstNameKanaSC: this.state.firstNameKanaSC,
          telSC: this.state.telSC,
          emailSC: this.state.emailSC,
        }
    }

    const { enqueueSnackbar } = this.props;

    API.post(apiName, path, myInit).then(response => {
      console.log(response)
      this.setState({
        searchCustomersResult: response.customers
      });
      if(response.customers.length > 0){
        enqueueSnackbar(response.customers.length + '件が該当しました。', {variant : 'success'});
      }else{
        enqueueSnackbar('該当する顧客がいません。', {variant : 'warning'});
      }

    }).catch(error => {
      console.log(error)
      if(error.message){
        enqueueSnackbar(error.message, {variant : 'error'})
      }else{
        enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
      }
    })
  }

  setRepeatCustomer = (customerId) => {
    console.log("repeatCustomerId: ", customerId)

    const repeatCustomer = this.state.searchCustomersResult.find((customer) => {
      return (customer.customer_id === customerId);
    });

    this.setState({
      isRepeatCustomer: "yes",
      repeatCustomerId: customerId,
      repeatCustomerOpen: false,
      lastNameKanaSC: "",
      firstNameKanaSC: "",
      telSC: "",
      emailSC: "",
      lastName: repeatCustomer.last_name,
      firstName: repeatCustomer.first_name,
      lastNameKana: repeatCustomer.last_name_kana,
      firstNameKana: repeatCustomer.first_name_kana,
      tel: repeatCustomer.tel,
      tel2: repeatCustomer.tel2 ? repeatCustomer.tel2 : "",
      email: repeatCustomer.email ? repeatCustomer.email : "",
      postNum: repeatCustomer.post_num ? repeatCustomer.post_num : "",
      addressPrefectures: repeatCustomer.address_prefectures,
      addressCity: repeatCustomer.address_city,
      addressOther: repeatCustomer.address_other ? repeatCustomer.address_other : "",
      addressBuilding: repeatCustomer.address_building ? repeatCustomer.address_building : "",
      customerNote: repeatCustomer.customer_note ? repeatCustomer.customer_note : "",
    });
  }

  nl2brJsx = (str) =>{
    let lines = [];
    let array = str.split("\n");
    for(let i in array){
      lines.push(<Fragment key={"lines" + i}>{array[i]}<br/></Fragment>);
    }
    return lines;
  }

  handleleOnFocus = (value, key) => {
    this.setState({
      [key + "OnFocus"] : value
    })
  }


  render() {
    const {classes, theme} = this.props
    const {
      date,
      dateNum,
      inputRooms,
      rooms,
      roomError,
      inputBasePlan,
      inputBedPlan,
      inputMealPlan,
      inputUnitPrice,
      inputAmount,
      plans,
      planError,
      isJalan,
      isActiveJalanSiteController,
      isWaitingSiteController,
      jalanPaid,
      extraCharge,
      discount,
      gotoDiscount,
      jalanNumber,
      jalanPoint,
      jalanCoupon,
      jalanSubsidy,
      taxRate,
      planShortageError,
      planNegativeError,
      babyChairs,
      joinBed,
      plasticBag,
      familyMemberOpen,
      scroll,
      babyM,
      babyW,
      kindergartenM,
      kindergartenW,
      elementarySchoolLowM,
      elementarySchoolLowW,
      elementarySchoolMiddleM,
      elementarySchoolMiddleW,
      elementarySchoolHighM,
      elementarySchoolHighW,
      juniorHighSchoolM,
      juniorHighSchoolW,
      highSchoolM,
      highSchoolW,
      universityM,
      universityW,
      twentiesM,
      twentiesW,
      thirtiesM,
      thirtiesW,
      fortiesM,
      fortiesW,
      fiftiesM,
      fiftiesW,
      sixtiesM,
      sixtiesW,
      overSeventiesM,
      overSeventiesW,
      transportation,
      planNote,
      isRepeatCustomer,
      repeatCustomerId,
      searchCustomersResult,
      repeatCustomerOpen,
      lastNameKanaSC,
      firstNameKanaSC,
      telSC,
      emailSC,
      lastName,
      lastNameOnFocus,
      lastNameList,
      firstName,
      lastNameKana,
      lastNameKanaOnFocus,
      firstNameKana,
      tel,
      tel2,
      email,
      postNum,
      addressPrefectures,
      addressCity,
      addressOther,
      addressBuilding,
      customerNote,
    } = this.state;

    return (
      <Fragment>
        <ScrollToTopOnMount/>
        <Grid container spacing={24} className={classes.container}>
          <Grid item xs={12}>
            <Typography variant="h4" gutterBottom>
              予約受付
            </Typography>
          </Grid>
          <Grid item>
            <ValidatorForm
              ref="form"
              onSubmit={(e) => this.handleSubmit(e)}
              onError={
                errors => {
                  console.log(errors);
                  const { enqueueSnackbar } = this.props;
                  enqueueSnackbar('入力エラーがあります。確認してください。', {variant : 'warning'});
                }
              }
            >
              <Paper className={classes.root} elevation={1}>
                <Typography variant="h5" gutterBottom>
                  宿泊情報
                </Typography>
                <TextValidator
                  className={classes.textField}
                  name="date"
                  label="宿泊開始日"
                  value={date}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'date')}
                  type="date"
                  required={true}
                  validators={['required', 'matchRegexp:^\\d{4}-\\d{1,2}-\\d{1,2}$']}
                  errorMessages={['必須項目を入力してください', '日付が間違っています']}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <TextValidator
                  className={classes.textField}
                  name="dateNum"
                  label="宿泊日数"
                  value={dateNum}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'dateNum')}
                  type="number"
                  required={true}
                  validators={['required', 'isNumber', 'minNumber:1']}
                  errorMessages={['必須項目を入力してください', '整数を入力してください', '1以上の数を入力してください']}
                />
                <br/>
                <FormControl required={true} error={roomError} className={classes.formControl} style={{minWidth: 120, maxWidth: 300}}>
                  <InputLabel htmlFor="select-multiple-chip">お部屋</InputLabel>
                  <Select
                    multiple
                    autoWidth={true}
                    value={inputRooms}
                    onChange={(e) => this.handleChange(e, 'inputRooms')}
                    input={<Input id="select-multiple-chip" />}
                    renderValue={selected => (
                      <div className={classes.chips}>
                        {selected.map(value => (
                          <Chip key={value} label={value} className={classes.chip} />
                        ))}
                      </div>
                    )}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 488,
                          width: 250,
                        },
                      },
                    }}
                  >
                    {roomNames.map(room => (
                      <MenuItem
                        key={room}
                        value={room}
                        name="room"
                        style={{
                          fontWeight:
                            room.indexOf(room) === -1
                              ? theme.typography.fontWeightRegular
                              : theme.typography.fontWeightMedium,
                        }}
                      >
                        {room}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{roomError ? "お部屋を指定してください" : ""}</FormHelperText>
                </FormControl>
                <Chip
                  label={(() => {
                    let capacity = 0
                    if(rooms.length !== 0){
                      rooms.forEach(room => (capacity += room.capacity))
                    }
                    return "お部屋の定員の合計:　　　" + capacity

                  })()}
                  className={classes.chip}
                  style={{marginLeft:30, marginBottom:26, verticalAlign:"bottom", width:200, backgroundColor:"#efefef"}}
                />
                <br/>
              <Paper className={classes.root}>
                <Typography variant="subtitle1" gutterBottom>
                  プラン*
                </Typography>
                <div style={{display: planError}}>
                  <Typography color="error" style={{display: "inline-flex", verticalAlign:"middle", marginTop:10}}>
                    <ErrorIcon style={{marginTop: -3}} />プランを入力してください
                  </Typography>
                  <br/>
                </div>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={(e) => this.handleChangeCheck(e,'isJalan')}
                      value={isJalan}
                      checked={isJalan === "yes" ? true : false }
                      color="primary"
                    />
                  }
                  label="じゃらん予約"
                  style={{marginTop:10}}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={(e) => this.handleChangeCheck(e,'jalanPaid')}
                      value={jalanPaid}
                      checked={jalanPaid === "yes" ? true : false }
                      color="primary"
                    />
                  }
                  label="じゃらん支払済"
                  style={{marginTop:10, display:isJalan === "yes" ? "" : "none"}}
                />
                <br/>
                <FormControl className={classes.formControl} style={{marginBottom:30, width:150}}>
                  <InputLabel htmlFor="customer-type-helper">ベースプラン</InputLabel>
                  <Select
                    value={inputBasePlan}
                    onChange={(e) => this.handleChange(e,'inputBasePlan')}
                    input={<Input name="type" id="customer-type-helper" />}
                    style={{paddingTop:8}}
                  >
                    <MenuItem value=""><em>None</em></MenuItem>
                    <MenuItem value={'大人'}>大人</MenuItem>
                    <MenuItem value={'ジュニア'}>ジュニア</MenuItem>
                    <MenuItem value={'キッズ'}>キッズ</MenuItem>
                    <MenuItem value={'素泊り'}>素泊り</MenuItem>
                  </Select>
                </FormControl>
                <FormControl className={classes.formControl} style={{marginBottom:30, width:100}}>
                  <InputLabel htmlFor="customer-type-helper">ベッド</InputLabel>
                  <Select
                    value={inputBedPlan}
                    onChange={(e) => this.handleChange(e,'inputBedPlan')}
                    input={<Input name="type" id="customer-type-helper" />}
                    style={{paddingTop:8}}
                  >
                    <MenuItem value=""><em>None</em></MenuItem>
                    <MenuItem value={'有'}>有</MenuItem>
                    <MenuItem value={'無'}>無</MenuItem>
                  </Select>
                </FormControl>
                <FormControl
                  disabled={inputBasePlan === "素泊り" ? true : false}
                  className={classes.formControl}
                  style={{marginBottom:30, width:120}}
                >
                  <InputLabel htmlFor="customer-type-helper">{inputBasePlan === "素泊り" ? "食事なし" : "食事"}</InputLabel>
                  <Select
                    value={inputMealPlan}
                    onChange={(e) => this.handleChange(e,'inputMealPlan')}
                    input={<Input name="type" id="customer-type-helper" />}
                    style={{paddingTop:8}}
                  >
                    <MenuItem value=""><em>None</em></MenuItem>
                    <MenuItem value={'2食付'}>2食付</MenuItem>
                    <MenuItem value={'朝食付'}>朝食付</MenuItem>
                    <MenuItem value={'夕食付'}>夕食付</MenuItem>
                  </Select>
                </FormControl>
                <TextValidator
                  className={classes.textField}
                  name="inputUnitPrice"
                  label="単価"
                  value={inputUnitPrice}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'inputUnitPrice')}
                  type="number"
                  validators={['isNumber', 'minNumber:1']}
                  errorMessages={['整数を入力してください', '1以上の数を入力してください']}
                  style={{width:170}}
                />
                <TextValidator
                  className={classes.textField}
                  name="inputAmount"
                  label="人数"
                  value={inputAmount}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'inputAmount')}
                  type="number"
                  validators={['isNumber', 'minNumber:1']}
                  errorMessages={['整数を入力してください', '1以上の数を入力してください']}
                  style={{width:80}}
                />
                <Button onClick={this.handleAddPlan} variant="contained" color="default" className={classes.button} style={{marginLeft:10, marginTop:25}}>
                  追加
                </Button>
                <br/>
                <TextValidator
                  className={classes.textField}
                  name="extraCharge"
                  label="追加チャージ"
                  value={extraCharge}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'extraCharge')}
                  type="number"
                  validators={['isNumber', 'minNumber:0']}
                  errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                  style={{width:170, display:isJalan === "no" ? "" : "none"}}
                />
                <TextValidator
                  className={classes.textField}
                  name="discount"
                  label="割引"
                  value={discount}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'discount')}
                  type="number"
                  validators={['isNumber', 'minNumber:0']}
                  errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                  style={{width:170, display:isJalan === "no" ? "" : "none"}}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={(e) => this.handleChangeCheck(e,'gotoDiscount')}
                      value={gotoDiscount}
                      checked={gotoDiscount === "yes" ? true : false }
                      color="primary"
                    />
                  }
                  label="GoToキャンペーン35%割引"
                  style={{marginLeft:10, marginTop:20, display:isJalan === "no" ? "" : "none"}}
                />
                <TextValidator
                  className={classes.textField}
                  name="jalanNumber"
                  label="じゃらん No."
                  value={jalanNumber}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'jalanNumber')}
                  type="number"
                  required={isJalan === "yes" ? true : false}
                  validators={['isNumber']}
                  errorMessages={['整数を入力してください']}
                  style={{width: 130, display:isJalan === "yes" ? "" : "none"}}
                />
                <br/>
                <TextValidator
                  className={classes.textField}
                  name="jalanPoint"
                  label="ポイント利用額"
                  value={jalanPoint}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'jalanPoint')}
                  type="number"
                  validators={['isNumber', 'minNumber:0']}
                  errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                  style={{width: 130, display:isJalan === "yes" ? "" : "none"}}
                />
                <TextValidator
                  className={classes.textField}
                  name="jalanCoupon"
                  label="クーポン利用額"
                  value={jalanCoupon}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'jalanCoupon')}
                  type="number"
                  validators={['isNumber', 'minNumber:0']}
                  errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                  style={{width: 130, display:isJalan === "yes" ? "" : "none"}}
                />
                <TextValidator
                  className={classes.textField}
                  name="jalanSubsidy"
                  label="補助金利用額"
                  value={jalanSubsidy}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'jalanSubsidy')}
                  type="number"
                  validators={['isNumber', 'minNumber:0']}
                  errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                  style={{width: 130, display:isJalan === "yes" ? "" : "none"}}
                />
                <br/>
                <div style={{display: planShortageError, textAlign:'right'}}>
                  <Typography color="error" style={{display: "inline-flex", verticalAlign:"middle", marginBottom:10}}>
                    <ErrorIcon style={{marginTop: -3}} />すべての項目を入力してください
                  </Typography>
                  <br/>
                </div>
                <br/>
                <div style={{display: planNegativeError, textAlign:'right'}}>
                  <Typography color="error" style={{display: "inline-flex", verticalAlign:"middle", marginBottom:10}}>
                    <ErrorIcon style={{marginTop: -3}} />金額がプラスになるように入力してください
                  </Typography>
                  <br/>
                </div>
                  <Table className={classes.table}>
                    <TableHead style={{backgroundColor:"#f3f3f3"}}>
                      <TableRow>
                        <TableCell style={{color: "#676767"}}>ベースプラン</TableCell>
                        <TableCell style={{color: "#676767"}}>ベッド</TableCell>
                        <TableCell style={{color: "#676767"}}>食事</TableCell>
                        <TableCell style={{color: "#676767"}} align="right">単価</TableCell>
                        <TableCell style={{color: "#676767"}} align="right">人数</TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {plans.map(n =>
                        {
                          return (
                            <TableRow key={n.id}>
                              <TableCell>{n.basePlan}</TableCell>
                              <TableCell>{n.bedPlan}</TableCell>
                              <TableCell>{n.mealPlan}</TableCell>
                              <TableCell align="right">￥{Number(n.unitPrice).toLocaleString()}</TableCell>
                              <TableCell align="right">{n.amount}名</TableCell>
                              <TableCell>
                                <IconButton className={classes.button} aria-label="Delete" onClick={() => this.handleDeletePlan(n.id)}>
                                  <DeleteIcon />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          );
                        }
                      )}
                      <TableRow key="space">
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                      <TableRow key="totalAmount" style={{backgroundColor:"#f3f3f3"}}>
                        <TableCell>人数合計</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell align="right">{this.getTotalAmount()}名</TableCell>
                      </TableRow>
                      <TableRow key="totalPrice" style={{backgroundColor:"#d0d0d0"}}>
                        <TableCell>宿泊料金小計</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell align="right">￥{Number(this.getTotalPrice()).toLocaleString()}</TableCell>
                      </TableRow>
                      <TableRow key="extraCharge" style={{backgroundColor:"#f3f3f3", display:isJalan === "no" ? "" : "none"}}>
                        <TableCell>追加チャージ</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell align="right">￥{Number(extraCharge).toLocaleString()}</TableCell>
                      </TableRow>
                      <TableRow key="discount" style={{backgroundColor:"#f3f3f3", display:isJalan === "no" ? "" : "none"}}>
                        <TableCell>割引</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell align="right">- ￥{Number(discount).toLocaleString()}</TableCell>
                      </TableRow>

                      {/* GoToキャンペーンの計算 */}
                      <TableRow key="totalPriceWithTax" style={{backgroundColor:"#d0d0d0", display:gotoDiscount === "yes" ? "" : "none"}}>
                        <TableCell>宿泊料金小計(税込)</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell align="right">￥{Math.ceil(Math.floor(((Number(this.getTotalPrice()) + Number(extraCharge) - Number(discount)) * (1 + Number(taxRate))))).toLocaleString()}</TableCell>
                      </TableRow>
                      <TableRow key="goto" style={{backgroundColor:"#f3f3f3", display:gotoDiscount === "yes" ? "" : "none"}}>
                        <TableCell>GoToキャンペーン割引(35%)</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell align="right">- ￥{Math.ceil(Math.floor(((Number(this.getTotalPrice()) + Number(extraCharge) - Number(discount)) * (1 + Number(taxRate)))) * 0.35).toLocaleString()}</TableCell>
                      </TableRow>

                      <TableRow key="totalPriceAddAll" style={{backgroundColor:"#d0d0d0", display:isJalan === "no" ? gotoDiscount === "yes" ? "none" : "" : "none"}}>
                        <TableCell>宿泊料金合計</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell align="right">￥{(Number(this.getTotalPrice()) + Number(extraCharge) - Number(discount)).toLocaleString()}</TableCell>
                      </TableRow>

                      <TableRow key="tax" style={{backgroundColor:"#f3f3f3", display:isJalan === "no" ? gotoDiscount === "yes" ? "none" : "" : "none"}}>
                        <TableCell>消費税({taxRate * 100}%)</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell align="right">￥{Math.floor(((Number(this.getTotalPrice()) + Number(extraCharge) - Number(discount)) * taxRate)).toLocaleString()}</TableCell>
                      </TableRow>

                      <TableRow key="totalPriceGoto" style={{backgroundColor:"#d0d0d0", display:isJalan === "no" ? gotoDiscount === "yes" ? "" : "none" : "none"}}>
                        <TableCell>ご請求金額(税込)</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell align="right">￥{(Math.floor(((Number(this.getTotalPrice()) + Number(extraCharge) - Number(discount)) * (1 + Number(taxRate)))) - Math.ceil(Math.floor(((Number(this.getTotalPrice()) + Number(extraCharge) - Number(discount)) * (1 + Number(taxRate)))) * 0.35)).toLocaleString()}</TableCell>
                      </TableRow>

                      <TableRow key="totalPricePlusTax" style={{backgroundColor:"#d0d0d0", display:isJalan === "no" ? gotoDiscount === "yes" ? "none" : "" : "none"}}>
                        <TableCell>ご請求金額(税込)</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell align="right">￥{Math.floor(((Number(this.getTotalPrice()) + Number(extraCharge) - Number(discount)) * (1 + Number(taxRate)))).toLocaleString()}</TableCell>
                      </TableRow>
                      {/* GoToキャンペーンの計算 */}

                      <TableRow key="jalanDiscount" style={{backgroundColor:"#f3f3f3", display:isJalan === "yes" ? "" : "none"}}>
                        <TableCell>じゃらん割引額</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell align="right">- ￥{(Number(jalanPoint) + Number(jalanCoupon) + Number(jalanSubsidy)).toLocaleString()}</TableCell>
                      </TableRow>
                      <TableRow key="totalPriceAddDiscount" style={{backgroundColor:"#d0d0d0", display:isJalan === "yes" ? "" : "none"}}>
                        <TableCell>ご請求金額(税込)</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell align="right">￥{(Number(this.getTotalPrice()) - (Number(jalanPoint) + Number(jalanCoupon) + Number(jalanSubsidy))).toLocaleString()}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                  <Typography style={{margin:20, color:"#8c8c8c"}}>
                    ■追加チャージ<br/>
                    ※ツインルーム: シングルチャージは +1800円 (税別料金に追加)<br/>
                    ※トリプル・カルテット・レビュラー: 減1ベッド時はベッド使用者が +1000円 (税別料金に追加)
                  </Typography>
                  <div style={
                    {
                      display:
                      (Number(this.getTotalPrice()) - (Number(jalanPoint) + Number(jalanCoupon) + Number(jalanSubsidy))) < 0 ||
                      (Number(this.getTotalPrice()) + Number(extraCharge) - Number(discount)) < 0
                      ? ""
                      : "none"
                      ,
                      textAlign:'right',
                      marginTop: 15
                    }
                  }>
                    <Typography color="error" style={{display: "inline-flex", verticalAlign:"middle"}}>
                      <ErrorIcon style={{marginTop: -3}} />合計金額がマイナスになっています
                    </Typography>
                    <br/>
                  </div>
                </Paper>
                <br/>
                <TextValidator
                  className={classes.textField}
                  name="joinBed"
                  label="くっつけるベッド数"
                  value={joinBed}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'joinBed')}
                  type="number"
                  min="0"
                  required={true}
                  validators={['required', 'isNumber', 'minNumber:0']}
                  errorMessages={['必須項目を入力してください', '整数を入力してください', '0以上の数を入力してください']}
                  style={{width: 150}}
                />
                <TextValidator
                  className={classes.textField}
                  name="babyChairs"
                  label="幼児用椅子の数"
                  value={babyChairs}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'babyChairs')}
                  type="number"
                  min="0"
                  required={true}
                  validators={['required', 'isNumber', 'minNumber:0']}
                  errorMessages={['必須項目を入力してください', '整数を入力してください', '0以上の数を入力してください']}
                  style={{width: 150}}
                />
                <FormControlLabel className={classes.PlasticBagCheckboxFormControl}
                  control={
                    <Checkbox
                      onChange={(e) => this.handleChangeCheck(e,'plasticBag')}
                      value={plasticBag}
                      checked={plasticBag === "yes" ? true : false }
                      color="primary"
                    />
                  }
                  label="ビニール袋必要"
                />
                <br/>
                <br/>
                <Button variant="contained" color="default" onClick={() => this.handleClickOpenDialog('paper', 'familyMemberOpen')} style={{marginLeft:5, marginTop:18}}>顧客構成</Button>
                <Dialog
                  open={familyMemberOpen}
                  onClose={() => this.handleCloseDialog('familyMemberOpen')}
                  scroll={scroll}
                  aria-labelledby="scroll-dialog-title"
                >
                  <DialogTitle id="scroll-dialog-title">顧客構成</DialogTitle>
                  <DialogContent>
                    <Typography variant="subtitle1" style={{display:'inline', marginRight: 135}}>
                      男性
                    </Typography>
                    <Typography variant="subtitle1" style={{display:'inline'}}>
                      女性
                    </Typography>
                    <br/>
                    <TextValidator
                      className={classes.textField}
                      name="babyM"
                      label="〜3歳"
                      value={babyM}
                      margin="normal"
                      onChange={(e) => this.handleChange(e, 'babyM')}
                      type="number"
                      min="0"
                      validators={['isNumber', 'minNumber:0']}
                      errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                      style={{width: 150}}
                    />
                    <TextValidator
                      className={classes.textField}
                      name="babyW"
                      label="〜3歳"
                      value={babyW}
                      margin="normal"
                      onChange={(e) => this.handleChange(e, 'babyW')}
                      type="number"
                      min="0"
                      validators={['isNumber', 'minNumber:0']}
                      errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                      style={{width: 150}}
                    />
                    <br/>
                    <TextValidator
                      className={classes.textField}
                      name="kindergartenM"
                      label="幼稚園児"
                      value={kindergartenM}
                      margin="normal"
                      onChange={(e) => this.handleChange(e, 'kindergartenM')}
                      type="number"
                      min="0"
                      validators={['isNumber', 'minNumber:0']}
                      errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                      style={{width: 150}}
                    />
                    <TextValidator
                      className={classes.textField}
                      name="kindergartenW"
                      label="幼稚園児"
                      value={kindergartenW}
                      margin="normal"
                      onChange={(e) => this.handleChange(e, 'kindergartenW')}
                      type="number"
                      min="0"
                      validators={['isNumber', 'minNumber:0']}
                      errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                      style={{width: 150}}
                    />
                    <br/>
                    <TextValidator
                      className={classes.textField}
                      name="elementarySchoolLowM"
                      label="小学校低学年"
                      value={elementarySchoolLowM}
                      margin="normal"
                      onChange={(e) => this.handleChange(e, 'elementarySchoolLowM')}
                      type="number"
                      min="0"
                      validators={['isNumber', 'minNumber:0']}
                      errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                      style={{width: 150}}
                    />
                    <TextValidator
                      className={classes.textField}
                      name="elementarySchoolLowW"
                      label="小学校低学年"
                      value={elementarySchoolLowW}
                      margin="normal"
                      onChange={(e) => this.handleChange(e, 'elementarySchoolLowW')}
                      type="number"
                      min="0"
                      validators={['isNumber', 'minNumber:0']}
                      errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                      style={{width: 150}}
                    />
                    <br/>
                    <TextValidator
                      className={classes.textField}
                      name="elementarySchoolMiddleM"
                      label="小学校中学年"
                      value={elementarySchoolMiddleM}
                      margin="normal"
                      onChange={(e) => this.handleChange(e, 'elementarySchoolMiddleM')}
                      type="number"
                      min="0"
                      validators={['isNumber', 'minNumber:0']}
                      errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                      style={{width: 150}}
                    />
                    <TextValidator
                      className={classes.textField}
                      name="elementarySchoolMiddleW"
                      label="小学校中学年"
                      value={elementarySchoolMiddleW}
                      margin="normal"
                      onChange={(e) => this.handleChange(e, 'elementarySchoolMiddleW')}
                      type="number"
                      min="0"
                      validators={['isNumber', 'minNumber:0']}
                      errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                      style={{width: 150}}
                    />
                    <br/>
                    <TextValidator
                      className={classes.textField}
                      name="elementarySchoolHighM"
                      label="小学校高学年"
                      value={elementarySchoolHighM}
                      margin="normal"
                      onChange={(e) => this.handleChange(e, 'elementarySchoolHighM')}
                      type="number"
                      min="0"
                      validators={['isNumber', 'minNumber:0']}
                      errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                      style={{width: 150}}
                    />
                    <TextValidator
                      className={classes.textField}
                      name="elementarySchoolHighW"
                      label="小学校高学年"
                      value={elementarySchoolHighW}
                      margin="normal"
                      onChange={(e) => this.handleChange(e, 'elementarySchoolHighW')}
                      type="number"
                      min="0"
                      validators={['isNumber', 'minNumber:0']}
                      errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                      style={{width: 150}}
                    />
                    <br/>
                    <TextValidator
                      className={classes.textField}
                      name="juniorHighSchoolM"
                      label="中学生"
                      value={juniorHighSchoolM}
                      margin="normal"
                      onChange={(e) => this.handleChange(e, 'juniorHighSchoolM')}
                      type="number"
                      min="0"
                      validators={['isNumber', 'minNumber:0']}
                      errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                      style={{width: 150}}
                    />
                    <TextValidator
                      className={classes.textField}
                      name="juniorHighSchoolW"
                      label="中学生"
                      value={juniorHighSchoolW}
                      margin="normal"
                      onChange={(e) => this.handleChange(e, 'juniorHighSchoolW')}
                      type="number"
                      min="0"
                      validators={['isNumber', 'minNumber:0']}
                      errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                      style={{width: 150}}
                    />
                    <br/>
                    <TextValidator
                      className={classes.textField}
                      name="highSchoolM"
                      label="高校生"
                      value={highSchoolM}
                      margin="normal"
                      onChange={(e) => this.handleChange(e, 'highSchoolM')}
                      type="number"
                      min="0"
                      validators={['isNumber', 'minNumber:0']}
                      errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                      style={{width: 150}}
                    />
                    <TextValidator
                      className={classes.textField}
                      name="highSchoolW"
                      label="高校生"
                      value={highSchoolW}
                      margin="normal"
                      onChange={(e) => this.handleChange(e, 'highSchoolW')}
                      type="number"
                      min="0"
                      validators={['isNumber', 'minNumber:0']}
                      errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                      style={{width: 150}}
                    />
                    <br/>
                    <TextValidator
                      className={classes.textField}
                      name="universityM"
                      label="大学生(19歳-22歳)"
                      value={universityM}
                      margin="normal"
                      onChange={(e) => this.handleChange(e, 'universityM')}
                      type="number"
                      min="0"
                      validators={['isNumber', 'minNumber:0']}
                      errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                      style={{width: 150}}
                    />
                    <TextValidator
                      className={classes.textField}
                      name="universityW"
                      label="大学生(19歳-22歳)"
                      value={universityW}
                      margin="normal"
                      onChange={(e) => this.handleChange(e, 'universityW')}
                      type="number"
                      min="0"
                      validators={['isNumber', 'minNumber:0']}
                      errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                      style={{width: 150}}
                    />
                    <br/>
                    <TextValidator
                      className={classes.textField}
                      name="twentiesM"
                      label="20代"
                      value={twentiesM}
                      margin="normal"
                      onChange={(e) => this.handleChange(e, 'twentiesM')}
                      type="number"
                      min="0"
                      validators={['isNumber', 'minNumber:0']}
                      errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                      style={{width: 150}}
                    />
                    <TextValidator
                      className={classes.textField}
                      name="twentiesW"
                      label="20代"
                      value={twentiesW}
                      margin="normal"
                      onChange={(e) => this.handleChange(e, 'twentiesW')}
                      type="number"
                      min="0"
                      validators={['isNumber', 'minNumber:0']}
                      errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                      style={{width: 150}}
                    />
                    <br/>
                    <TextValidator
                      className={classes.textField}
                      name="thirtiesM"
                      label="30代"
                      value={thirtiesM}
                      margin="normal"
                      onChange={(e) => this.handleChange(e, 'thirtiesM')}
                      type="number"
                      min="0"
                      validators={['isNumber', 'minNumber:0']}
                      errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                      style={{width: 150}}
                    />
                    <TextValidator
                      className={classes.textField}
                      name="thirtiesW"
                      label="30代"
                      value={thirtiesW}
                      margin="normal"
                      onChange={(e) => this.handleChange(e, 'thirtiesW')}
                      type="number"
                      min="0"
                      validators={['isNumber', 'minNumber:0']}
                      errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                      style={{width: 150}}
                    />
                    <br/>
                    <TextValidator
                      className={classes.textField}
                      name="fortiesM"
                      label="40代"
                      value={fortiesM}
                      margin="normal"
                      onChange={(e) => this.handleChange(e, 'fortiesM')}
                      type="number"
                      min="0"
                      validators={['isNumber', 'minNumber:0']}
                      errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                      style={{width: 150}}
                    />
                    <TextValidator
                      className={classes.textField}
                      name="fortiesW"
                      label="40代"
                      value={fortiesW}
                      margin="normal"
                      onChange={(e) => this.handleChange(e, 'fortiesW')}
                      type="number"
                      min="0"
                      validators={['isNumber', 'minNumber:0']}
                      errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                      style={{width: 150}}
                    />
                    <br/>
                    <TextValidator
                      className={classes.textField}
                      name="fiftiesM"
                      label="50代"
                      value={fiftiesM}
                      margin="normal"
                      onChange={(e) => this.handleChange(e, 'fiftiesM')}
                      type="number"
                      min="0"
                      validators={['isNumber', 'minNumber:0']}
                      errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                      style={{width: 150}}
                    />
                    <TextValidator
                      className={classes.textField}
                      name="fiftiesW"
                      label="50代"
                      value={fiftiesW}
                      margin="normal"
                      onChange={(e) => this.handleChange(e, 'fiftiesW')}
                      type="number"
                      min="0"
                      validators={['isNumber', 'minNumber:0']}
                      errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                      style={{width: 150}}
                    />
                    <br/>
                    <TextValidator
                      className={classes.textField}
                      name="sixtiesM"
                      label="60代"
                      value={sixtiesM}
                      margin="normal"
                      onChange={(e) => this.handleChange(e, 'sixtiesM')}
                      type="number"
                      min="0"
                      validators={['isNumber', 'minNumber:0']}
                      errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                      style={{width: 150}}
                    />
                    <TextValidator
                      className={classes.textField}
                      name="sixtiesW"
                      label="60代"
                      value={sixtiesW}
                      margin="normal"
                      onChange={(e) => this.handleChange(e, 'sixtiesW')}
                      type="number"
                      min="0"
                      validators={['isNumber', 'minNumber:0']}
                      errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                      style={{width: 150}}
                    />
                    <br/>
                    <TextValidator
                      className={classes.textField}
                      name="overSeventiesM"
                      label="70代以上"
                      value={overSeventiesM}
                      margin="normal"
                      onChange={(e) => this.handleChange(e, 'overSeventiesM')}
                      type="number"
                      min="0"
                      validators={['isNumber', 'minNumber:0']}
                      errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                      style={{width: 150}}
                    />
                    <TextValidator
                      className={classes.textField}
                      name="overSeventiesW"
                      label="70代以上"
                      value={overSeventiesW}
                      margin="normal"
                      onChange={(e) => this.handleChange(e, 'overSeventiesW')}
                      type="number"
                      min="0"
                      validators={['isNumber', 'minNumber:0']}
                      errorMessages={['整数を入力してください', '0以上の数を入力してください']}
                      style={{width: 150}}
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={() => this.handleCloseDialog('familyMemberOpen')} color="primary">
                      閉じる
                    </Button>
                  </DialogActions>
                </Dialog>
                <FormControl className={classes.formControl} style={{width:150, marginLeft:50}}>
                  <InputLabel htmlFor="customer-type-helper">交通手段</InputLabel>
                  <Select
                    value={transportation}
                    onChange={(e) => this.handleChange(e,'transportation')}
                    input={<Input name="type" id="customer-type-helper" />}
                  >
                    <MenuItem value=""><em>None</em></MenuItem>
                    <MenuItem value={'車'}>車</MenuItem>
                    <MenuItem value={'バス'}>バス</MenuItem>
                    <MenuItem value={'未定'}>未定</MenuItem>
                  </Select>
                </FormControl>
                <br/>
                <TextValidator
                  className={classes.textField}
                  name="planNote"
                  label="備考"
                  value={planNote}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'planNote')}
                  required={false}
                  multiline={true}
                  rows={3}
                  style={{width:600}}
                />
              </Paper>
              <br/>
              <Paper className={classes.root} elevation={1} style={isRepeatCustomer === "yes" ? {backgroundColor: "#d2d2d2", transition: "0.3s"} : {transition: "0.3s"}}>
                <Typography variant="h5" gutterBottom>
                  顧客情報
                </Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={(e) => this.handleChangeCheck(e,'isRepeatCustomer')}
                      value={isRepeatCustomer}
                      checked={isRepeatCustomer === "yes" ? true : false }
                      color="primary"
                    />
                  }
                  label="リピーター"
                  style={{marginTop:10, marginBottom:10}}
                />
                <Button
                  variant="contained"
                  color="default"
                  onClick={() => this.handleClickOpenDialog('paper', 'repeatCustomerOpen')}
                  style={{marginLeft:10, display:isRepeatCustomer === "yes" ? "" : "none"}}
                >
                  顧客検索
                </Button>
                <br/>
                {isRepeatCustomer === "yes" && repeatCustomerId &&
                  <Fragment>
                    <Typography color="primary" style={{display: "inline-flex", verticalAlign:"middle", marginBottom:10}}>
                      <CheckCircleIcon style={{marginTop: -3}} />リピーター情報設定済み
                    </Typography>
                    <Typography variant= "body2" style={{marginBottom:20, marginLeft:10, color:"#585858"}}>
                      ※リピーターの情報を更新する場合は、更新箇所だけ変更してください。
                    </Typography>
                  </Fragment>
                }
                {isRepeatCustomer === "yes" && repeatCustomerId === "" &&
                  <Typography color="error" style={{display: "inline-flex", verticalAlign:"middle", marginBottom:20}}>
                    <ErrorIcon style={{marginTop: -3}} />リピーター情報を設定してください
                  </Typography>
                }
                <Typography variant="h6" gutterBottom>
                  お名前
                </Typography>
                <TextValidator
                  className={classes.textField}
                  name="lastNameKana"
                  label="氏(カナ)"
                  value={lastNameKana}
                  margin="normal"
                  onChange={(e) => this.doSearch(e, 'lastNameKana')}
                  onFocus ={() => this.handleleOnFocus("yes", "lastNameKana")}
                  onBlur  ={() => this.handleleOnFocus("no", "lastNameKana")}
                  pattern="^[ァ-ンヴー]+$ , [\\u30A1-\\u30FF]*"
                  required={true}
                  validators={['required', 'matchRegexp:^[ァ-ンヴー]+$']}
                  errorMessages={['必須項目を入力してください', 'カタカナで入力してください']}
                  helperText="カタカナ入力"
                />
                <Paper
                  square
                  style={{
                    position: "absolute",
                    zIndex : 1,
                    width: "600px",
                    maxHeight: "300px",
                    marginTop: "-20px",
                    marginLeft : "8px",
                    overflow : "scroll",
                    display: lastNameKanaOnFocus === "yes" && searchCustomersResult.length > 0 ? "" : "none",
                  }}
                >
                  <div
                    style={{
                      color: "#0000008a",
                      margin: "10px"
                    }}
                  >
                    リピーター候補
                  </div>
                  {searchCustomersResult.map(n => (
                    <MenuItem
                      key={n.customer_id}
                      onMouseDown={() => this.setRepeatCustomer(n.customer_id)}
                    >
                      {n.last_name} {n.first_name}
                      <span
                        style={{
                          fontSize: "0.7em",
                          marginLeft: "18px",
                          marginTop: "3px",
                          color: "#0000008a",
                          varticalAlign: "bottom"
                        }}
                      >
                        住所:
                      </span>
                      <span
                        style={{
                          fontSize: "0.8em",
                          marginLeft: "2px",
                          marginTop: "2px",
                          varticalAlign: "middle"
                        }}
                      >
                        {n.address_prefectures} {n.address_city}
                      </span>
                      <span
                        style={{
                          fontSize: "0.7em",
                          marginLeft: "18px",
                          marginTop: "3px",
                          color: "#0000008a",
                          varticalAlign: "bottom"
                        }}
                      >
                        前回宿泊日:
                      </span>
                      <span
                        style={{
                          fontSize: "0.8em",
                          marginLeft: "2px",
                          marginTop: "2px",
                          varticalAlign: "middle"
                        }}
                      >
                        {moment(n.reservation_date_history[0]).format("YYYY年MM月DD日(ddd)")}
                      </span>
                    </MenuItem>
                  ))}
                </Paper>
                <TextValidator
                  className={classes.textField}
                  name="firstNameKana"
                  label="名（カナ）"
                  value={firstNameKana}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'firstNameKana')}
                  pattern="^[ァ-ンヴー]+$ , [\\u30A1-\\u30FF]*"
                  required={true}
                  validators={['required', 'matchRegexp:^[ァ-ンヴー]+$']}
                  errorMessages={['必須項目を入力してください', 'カタカナで入力してください']}
                  helperText="カタカナ入力"
                />
                <br/>
                <TextValidator
                  className={classes.textField}
                  name="lastName"
                  label="氏"
                  value={lastName}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'lastName')}
                  onFocus ={() => this.handleleOnFocus("yes", "lastName")}
                  onBlur  ={() => this.handleleOnFocus("no", "lastName")}
                  required={true}
                  validators={['required']}
                  errorMessages={['必須項目を入力してください']}
                  helperText={lastNameList.length > 0 ? "氏の候補があります" : ""}
                />
                <Paper
                  square
                  style={{
                    position: "absolute",
                    zIndex : 1,
                    width: "600px",
                    maxHeight: "300px",
                    marginTop: "-20px",
                    marginLeft : "8px",
                    overflow : "scroll",
                    display: lastNameOnFocus === "yes" && lastNameList.length > 0 ? "" : "none",
                  }}
                >
                  <div
                    style={{
                      color: "#0000008a",
                      margin: "10px"
                    }}
                  >
                    氏の候補
                    <span
                      style={{
                        fontSize: "0.8em",
                        marginLeft: "3px"
                      }}
                    >
                      (世帯数の多い苗字順に表示されます)
                    </span>
                  </div>
                  {lastNameList.map(n => (
                    <MenuItem
                      key={n}
                      onMouseDown={() => this.handleChange({target:{value: n}}, "lastName")}
                    >
                      {n}
                    </MenuItem>
                  ))}
                </Paper>
                <TextValidator
                  className={classes.textField}
                  name="firstName"
                  label="名"
                  value={firstName}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'firstName')}
                  required={true}
                  validators={['required']}
                  errorMessages={['必須項目を入力してください']}
                />
                <br/><br/>
                <Typography variant="h6" gutterBottom>
                  ご住所
                </Typography>
                <TextValidator
                  className={classes.textField}
                  name="postNum"
                  label="〒 郵便番号"
                  value={postNum}
                  margin="normal"
                  onChange={(e) => this.doSearch(e, 'postNum')}
                  onBlur={(e) => this.changeChar(e, 'postNum')}
                  required={false}
                  validators={['matchRegexp:^\\d{7}$']}
                  errorMessages={['郵便番号が間違っています']}
                  helperText="ハイフンなし"
                />
                <br/>
                <TextValidator
                  className={classes.textField}
                  name="addressPrefectures"
                  label="都道府県"
                  value={addressPrefectures}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'addressPrefectures')}
                  required={true}
                  validators={['required']}
                  errorMessages={['必須項目を入力してください']}
                  helperText="ハイフンなし"
                />
                <TextValidator
                  className={classes.textField}
                  name="addressCity"
                  label="市区町村"
                  value={addressCity}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'addressCity')}
                  required={true}
                  validators={['required']}
                  errorMessages={['必須項目を入力してください']}
                  helperText="ハイフンなし"
                />
                <br/>
                <TextValidator
                  className={classes.textField}
                  name="addressOther"
                  label="以降の住所"
                  value={addressOther}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'addressOther')}
                  required={true}
                  validators={['required']}
                  style={{width:'95%'}}
                />
                <br/>
                <TextValidator
                  className={classes.textField}
                  name="addressBuilding"
                  label="建物名"
                  value={addressBuilding}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'addressBuilding')}
                  style={{width:'95%'}}
                />
                <br/><br/>
                <Typography variant="h6" gutterBottom>
                  ご連絡先
                </Typography>
                <TextValidator
                  className={classes.textField}
                  name="tel"
                  label="電話番号"
                  value={tel}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'tel')}
                  onBlur={(e) => this.changeChar(e, 'tel')}
                  type="tel"
                  required={true}
                  validators={['required', 'matchRegexp:^(0{1}\\d{9,10})$']}
                  errorMessages={['必須項目を入力してください', '電話番号が間違っています']}
                  helperText="ハイフンなし"
                />
                <TextValidator
                  className={classes.textField}
                  name="tel2"
                  label="電話番号2"
                  value={tel2}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'tel2')}
                  onBlur={(e) => this.changeChar(e, 'tel2')}
                  type="tel"
                  validators={['matchRegexp:^(0{1}\\d{9,10})$']}
                  errorMessages={['電話番号が間違っています']}
                  helperText="固定電話など ハイフンなし"
                />
                <br/>
                <TextValidator
                  className={classes.textField}
                  name="email"
                  label="email"
                  value={email}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'email')}
                  required={false}
                  validators={['isEmail']}
                  errorMessages={['emailアドレスが間違っています']}
                />
                <br/>
                <TextValidator
                  className={classes.textField}
                  name="customerNote"
                  label="備考"
                  value={customerNote}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'customerNote')}
                  required={false}
                  multiline={true}
                  rows={3}
                  style={{width:600}}
                />
              </Paper>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={(e) => this.handleChangeCheck(e,'isActiveJalanSiteController')}
                    value={isActiveJalanSiteController}
                    checked={isActiveJalanSiteController === "yes" ? true : false }
                    color="primary"
                  />
                }
                label="じゃらんの在庫を変更しない"
                style={{marginTop:10, marginLeft:-3, display:isJalan === "no" ? "" : "none"}}
              />
              <br/>
              <Button type="submit" variant="contained" color="primary" className={classes.button} style={{marginTop:10, marginBottom:50}}>
                予約受付
              </Button>
            </ValidatorForm>
          </Grid>
        </Grid>
        <div style={{fontSize:5, textAlign:'right', margin:20}}>名字候補 出典 <a href='https://myoji-yurai.net/howToUse.htm'>名字由来net</a></div>



        <Dialog
          open={repeatCustomerOpen}
          onClose={() => this.handleCloseDialog('repeatCustomerOpen')}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          fullWidth={true}
          maxWidth="md"
        >
          <DialogTitle id="scroll-dialog-title">顧客検索</DialogTitle>
          <DialogContent>
          <ValidatorForm
            ref="form"
            onSubmit={() => this.handleSearchCustomers()}
            onError={
              errors => {
                console.log(errors);
                const { enqueueSnackbar } = this.props;
                enqueueSnackbar('検索内容に無効な値が含まれています。', {variant : 'warning'});
              }
            }
          >
            <TextValidator
              className={classes.textField}
              name="lastNameKanaSC"
              label="氏(カナ)"
              value={lastNameKanaSC}
              margin="normal"
              onChange={(e) => this.handleChange(e, 'lastNameKanaSC')}
              pattern="^[ァ-ンヴー]+$ , [\\u30A1-\\u30FF]*"
              validators={['matchRegexp:^[ァ-ンヴー]+$']}
              errorMessages={['カタカナで入力してください']}
              helperText="カタカナ入力"
            />
            <TextValidator
              className={classes.textField}
              name="firstNameKanaSC"
              label="名（カナ）"
              value={firstNameKanaSC}
              margin="normal"
              onChange={(e) => this.handleChange(e, 'firstNameKanaSC')}
              pattern="^[ァ-ンヴー]+$ , [\\u30A1-\\u30FF]*"
              validators={['matchRegexp:^[ァ-ンヴー]+$']}
              errorMessages={['カタカナで入力してください']}
              helperText="カタカナ入力"
            />
            <br/>
            <TextValidator
              className={classes.textField}
              name="telSC"
              label="電話番号"
              value={telSC}
              margin="normal"
              onChange={(e) => this.handleChange(e, 'telSC')}
              type="tel"
              validators={['matchRegexp:^(0{1}\\d{1,10})$']}
              errorMessages={['電話番号形式で入力してください']}
              helperText="ハイフンなし"
            />
            <br/>
            <TextValidator
              className={classes.textField}
              name="emailSC"
              label="email"
              value={emailSC}
              margin="normal"
              onChange={(e) => this.handleChange(e, 'emailSC')}
            />
            <br/>
            <Typography style={{marginLeft: 10, marginTop:20, color:"#8c8c8c"}}>
              ※入力されている項目のみで前方一致の絞り込み検索
            </Typography>
            <br/>
            <Button type="submit" variant="contained" color="primary" className={classes.button} style={{marginTop:40}}>
              検索
            </Button>
          </ValidatorForm>
          <br/>
          <Chip
            label={"該当件数:　　　" + searchCustomersResult.length}
            className={classes.chip}
            style={{marginTop:20, marginLeft:"63%", width:150, backgroundColor:"#efefef"}}
          />
          {searchCustomersResult.map(n =>
            {
              return (
                <Card style={{width:"80%", marginTop:20, background: "#ececec"}} key={n.customer_id}>
                  <CardActionArea onClick={() => this.setRepeatCustomer(n.customer_id)}>
                    <CardContent>
                      <Typography className={classes.title} color="textSecondary" gutterBottom>
                        {n.last_name_kana} {n.first_name_kana}
                      </Typography>
                      <Typography variant="h5" component="h2">
                        {n.last_name} {n.first_name} <div style={{marginLeft: 10, fontSize:"0.8em", display: "inline"}}>様</div>
                      </Typography>
                      <Typography variant="caption" style={{marginTop:10, marginBottom:8}}>
                        前回宿泊開始日
                      </Typography>
                      <Typography variant="body1" style={{marginLeft:5}}>
                        {moment(n.reservation_date_history[0]).format("YYYY年MM月DD日(ddd)")}
                      </Typography>
                      <Typography variant="caption" style={{marginTop:10, marginBottom:8}}>
                        住所
                      </Typography>
                      <Typography variant="body1" style={{marginLeft:5}}>
                        {n.post_num　? "〒" : ""}{n.post_num　? n.post_num.slice(0, 3) : ""}{n.post_num　? "-" : ""}{n.post_num　? n.post_num.slice(4, 7): ""}<br/>
                        {n.address_prefectures} {n.address_city} {n.address_other} {n.address_building}
                      </Typography>
                      <Typography variant="caption" style={{marginTop:10, marginBottom:8}}>
                        電話番号
                      </Typography>
                      <Typography variant="body1" style={{marginLeft:5}}>
                        {n.tel}
                      </Typography>
                      {n.tel2 &&
                        <Fragment>
                          <Typography variant="caption" style={{marginTop:10, marginBottom:8}}>
                            電話番号2
                          </Typography>
                          <Typography variant="body1" style={{marginLeft:5}}>
                            {n.tel2}
                          </Typography>
                        </Fragment>
                      }
                      {n.email &&
                        <Fragment>
                          <Typography variant="caption" style={{marginTop:10, marginBottom:8}}>
                            email
                          </Typography>
                          <Typography variant="body1" style={{marginLeft:5}}>
                            {n.email}
                          </Typography>
                        </Fragment>
                      }
                      {n.customer_note &&
                        <Fragment>
                          <Typography variant="caption" style={{marginTop:10, marginBottom:8}}>
                            備考
                          </Typography>
                          <Typography variant="body1" style={{marginLeft:5}}>
                            {this.nl2brJsx(n.customer_note)}
                          </Typography>
                        </Fragment>
                      }
                    </CardContent>
                  </CardActionArea>
                </Card>
              );
            }
          )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.handleCloseDialog('repeatCustomerOpen')} color="primary">
              閉じる
            </Button>
          </DialogActions>
        </Dialog>


        <Dialog
        open={isWaitingSiteController}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        >
        <DialogTitle id="alert-dialog-title">
          じゃらん連携中
        </DialogTitle>
        <DialogContent style={{textAlign: "center",marginTop: 20}}>
          <CircularProgress color="inherit"/>
          <DialogContentText id="alert-dialog-description" style={{textAlign: "left", marginTop: 30}}>
            ページを閉じないでください<br/><br/>
            じゃらんの在庫の確認と変更を行っています<br/>
            この処理には数分かかる場合があります<br/><br/>
            しばらくおまちください...
          </DialogContentText>
        </DialogContent>
      </Dialog>

      </Fragment>
    );
  }
}

Reservation.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withSnackbar(withRouter(withStyles(styles, { withTheme: true })(Reservation)));
